<i2a-delegate-folders [title]="name" [displayAccessTitle]="false" [subTitle]="delegate.lastAccess | amDateFormat: 'LLL'"
    [viewMoreDetailsKey]="'button.viewMoreFolders'" [delegate]="delegateFolders" [isAlert]="isAlert"
    [warningLevel]="warningLevel" [hasAlert]="hasAlert" [hasAlertRecentlyClosed]="hasAlertRecentlyClosed"
    (onWarnClick)="warnClick($event)" [buttonOpenAlertModalKey]="'button.openAlertModalAnomaly'">

</i2a-delegate-folders>